import {Link as OriginalLink} from "react-router-dom";
import {ComponentProps} from "react";
import {Button} from '@app/components/ui/button';
import {RouteParams, RoutePaths} from "@gen/routes";

type ToType = ComponentProps<typeof OriginalLink>["to"];
type ParamsMap = false | Record<string, any>;

type RootAppProps<
    Href extends string,
    Params extends ParamsMap = false
> = Omit<ComponentProps<typeof OriginalLink>, "to"> &
    (
        { href: Href | (() => void); to?: Href }
        | { href?: Href | (() => void); to: Href }
        ) &
    Pick<ComponentProps<typeof Button>, "variant"> &
    { as?: "button" } &
    (Params extends false
        ? { params?: undefined }
        : (
            [Params[Extract<Href, keyof Params>]] extends [never] ? {params?: never}
            : { params: Params[Extract<Href, keyof Params>] })
        );


function RootApp<Href extends string, Params extends false | Record<Href, any>>({
                                                                                    href,
                                                                                    as,
                                                                                    variant,
                                                                                    to,
                                                                                    children,
                                                                                    params,
                                                                                    ...props
                                                                                }: RootAppProps<Href, Params>
) {

    if (as === "button") return (
        <Button variant={variant}>
            {children}
        </Button>
    );

    if (typeof href === "function") {
        return (
            <Button variant={variant} onClick={() => href()}>
                {children}
            </Button>
        );
    }
    let resolvedTo = (to ?? href) as string;

    //inject params
    if (params) resolvedTo = resolvedTo.replace(/:(\w+)/g, (_, key) => params[key]);

    return (
        <OriginalLink
            to={resolvedTo as ToType}
            {...props}
        >
            {children}
        </OriginalLink>
    )
}

function AppLink<Href extends RoutePaths | `${RoutePaths}?${string}`>(props: RootAppProps<Href, RouteParams>) {
  return <RootApp {...(props as RootAppProps<RoutePaths, RouteParams>)} />;
}

export function AnyLink(props: RootAppProps<string>) {
    return <RootApp {...props} />;
}

export default AppLink;
